export enum ClientWorkspaceType {
	TRASHED_NODES = 'TRASHED_NODES',
	NORMAL = 'NORMAL',
	UNASSIGNED_NODES = 'UNASSIGNED_NODES',
}

export interface ClientWorkspace {
	id: string;

	name: string;
	description: string;
	type: ClientWorkspaceType;

	emoji?: string;
	thumbnailUrl?: string;

	count: number;

	integrationId?: string | null;
	createdAt?: number;
	updatedAt?: number;
	lastSearchedAt?: number;
}
